import { BaseSymbol } from '@ui/assets/config/trade-pair-listings';
import { getNativeToken, TokenSymbol } from '@ui/constants/tokens';
import { ChainId } from '@ui/types/chain';

export const ORACLE_SUPPORTED_SYMBOLS = [
  'MON',
  'WMON',
  'WRAPPED_NATIVE',
] satisfies (TokenSymbol | BaseSymbol)[];

export type OracleSupportedSymbol = (typeof ORACLE_SUPPORTED_SYMBOLS)[number];

const SYMBOL_TO_ORACLE_PRICE_ID: Record<
  Exclude<OracleSupportedSymbol, 'WRAPPED_NATIVE'>,
  string
> = {
  MON: 'MON-USD',
  WMON: 'MON-USD',
};
export const getOraclePriceIdBySymbol = (
  supportedSymbol: OracleSupportedSymbol,
  chainId: ChainId,
) => {
  const nativeToken = getNativeToken(chainId).symbol;

  return (
    SYMBOL_TO_ORACLE_PRICE_ID[
      supportedSymbol as Exclude<OracleSupportedSymbol, 'WRAPPED_NATIVE'>
    ] ?? SYMBOL_TO_ORACLE_PRICE_ID[nativeToken]
  );
};
